import React from 'react'
import { withTheme } from 'styled-components'

const Chevron = ({ theme, show }) => {
  return (
    <svg
      className={`down ${show ? 'active' : ''}`}
      width="15px"
      height="9px"
      viewBox="0 0 15 9"
      version="1.1"
    >
      <g
        className="down-arrow"
        transform="matrix(-4.371139E-08 -1 1 -4.371139E-08 0.5 8.5)"
      >
        <path
          d="M1.37932 7.00325L7.83268 0.919462C8.05577 0.709108 8.05577 0.368072 7.83268 0.157718C7.60951 -0.0525727 7.24779 -0.0525727 7.02466 0.157718L0.167299 6.62238C-0.0557663 6.83273 -0.0557663 7.17377 0.167299 7.38412L7.02466 13.8488C7.25168 14.0555 7.61343 14.0495 7.83268 13.8355C8.04653 13.6267 8.04653 13.2958 7.83268 13.087L1.37932 7.00325Z"
          id="Path"
          fill={theme.colors.active1}
          stroke={theme.colors.active1}
          strokeWidth={1}
        />
      </g>
    </svg>
  )
}

export default withTheme(Chevron)
